import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'paymentCalculationMethod',
    'hourMethod',
    'minimumGuaranteeMethod',
    'workMethod',
    'border',
    'unitLabel',
    'timePeriodPattern',
    'enableWorkUnitCheck',
    'enableWorkUnit',
    'workUnitForm',
    'workUnit',
    'calculatePrice',
    'displayPrice',
    'displayPriceForm',
    'individualOnly',
    'agentIds',
    'scheduleAdjustment',
    'agentNotification',
    'invoiceEmail'
  ]

  connect() {
    this.enabledMethod()
    this.enabledWorkUnit()
    this.initIndividualOnlyTarget()
  }

  enabledMethod() {
    this.hourMethodTarget.classList.add('hidden')
    this.hourMethodTarget
      .querySelectorAll('input[name=creator\\[tax_included\\]]')
      .forEach((e) => e.setAttribute('disabled', true))
    this.minimumGuaranteeMethodTarget.classList.add('hidden')
    this.minimumGuaranteeMethodTarget
      .querySelectorAll('input[name=creator\\[tax_included\\]]')
      .forEach((e) => e.setAttribute('disabled', true))
    this.workMethodTarget.classList.add('hidden')
    this.borderTarget.classList.remove('hidden')
    this.unitLabelTarget.classList.remove('hidden')
    this.workUnitFormTargets.forEach((element) => {
      element.classList.add('hidden')
      element
        .querySelectorAll('input[name=creator\\[tax_included\\]]')
        .forEach((e) => e.setAttribute('disabled', true))
    })

    switch (this.paymentCalculationMethodTarget.value) {
      case 'hour_unit':
        this.hourMethodTarget.classList.remove('hidden')
        this.hourMethodTarget
          .querySelectorAll('input[name=creator\\[tax_included\\]]')
          .forEach((e) => e.removeAttribute('disabled'))
        break
      case 'minimum_guarantee':
        this.minimumGuaranteeMethodTarget.classList.remove('hidden')
        this.minimumGuaranteeMethodTarget
          .querySelectorAll('input[name=creator\\[tax_included\\]]')
          .forEach((e) => e.removeAttribute('disabled'))
        break
      case 'work_unit':
        this.workMethodTarget.classList.remove('hidden')
        break
      default:
        this.borderTarget.classList.add('hidden')
        this.unitLabelTarget.classList.add('hidden')
    }
  }

  enabledPattern(event) {
    this.enableWorkUnitCheckTarget.classList.add('hidden')
    const patternId = this.timePeriodPatternTarget.value
    if (event.params.available[patternId]) {
      this.enableWorkUnitCheckTarget.classList.remove('hidden')
    } else {
      this.enableWorkUnitTarget.checked = false
    }
    this.enabledWorkUnit()
  }

  displayNotificationCheckbox(event) {
    this.agentNotificationTarget.classList.add('hidden')
    if (event.target.checked)
      this.agentNotificationTarget.classList.remove('hidden')
  }

  displayInvoiceEmailForm(event) {
    this.invoiceEmailTarget.classList.add('hidden')
    if (event.target.checked) this.invoiceEmailTarget.classList.remove('hidden')
  }

  enabledWorkUnit() {
    this.workMethodTarget
      .querySelectorAll('input[name=creator\\[tax_included\\]]')
      .forEach((e) => e.setAttribute('disabled', true))
    this.workUnitFormTargets.forEach((element) =>
      element.classList.add('hidden')
    )
    this.displayPriceFormTargets.forEach((element) =>
      element.classList.add('hidden')
    )
    this.displayPriceTargets.forEach((element) =>
      element.classList.add('hidden')
    )
    if (this.paymentCalculationMethodTarget.value !== 'work_unit') return

    if (this.enableWorkUnitTarget.checked) {
      this.workUnitFormTargets.forEach((element) => {
        element.classList.remove('hidden')
        element
          .querySelectorAll('input[name=creator\\[tax_included\\]]')
          .forEach((e) => e.removeAttribute('disabled'))
      })
      this.displayPriceTargets
        .find((element) => element.id === this.timePeriodPatternTarget.value)
        ?.classList?.remove('hidden')
    } else {
      this.displayPriceFormTargets
        .find((element) => element.id === this.timePeriodPatternTarget.value)
        ?.classList?.remove('hidden')
      const taxForm = this.displayPriceFormTargets.find(
        (e) => e.id === 'display_price_form_tax_included'
      )
      taxForm?.classList?.remove('hidden')
      taxForm
        ?.querySelectorAll('input[name=creator\\[tax_included\\]]')
        .forEach((e) => e.removeAttribute('disabled'))
    }
  }

  calculateWorkUnit(event) {
    let i = 0
    const price = this.workUnitTarget.value
    this.calculatePriceTargets.forEach((element) => {
      const weight = event.params.weight[i]
      element.textContent = (price * weight).toLocaleString() + ' 円'
      i += 1
    })
  }

  initIndividualOnlyTarget() {
    if (this.agentIdsTarget.selectedOptions.length > 0) {
      this.hideIndividualOnly()
    } else {
      this.showIndividualOnly()
    }
  }

  agentChanged(event) {
    if (event.target.selectedOptions.length > 0) {
      this.hideIndividualOnly()
    } else {
      this.showIndividualOnly()
    }
  }

  hideIndividualOnly() {
    this.individualOnlyTargets.forEach((e) => {
      e.classList.add('hidden')
    })
  }

  showIndividualOnly() {
    this.individualOnlyTargets.forEach((e) => {
      e.classList?.remove('hidden')
    })
  }
}
